import { GET_CARBON_EMISSION_SUCCESS } from '../actions';

const initialState = {
  carbonEmission: {},
};

export const carbonReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CARBON_EMISSION_SUCCESS:
      return {
        ...state,
        carbonEmission: action.payload,
      };
    default:
      return state;
  }
};
